import { __module as r } from "../../../_virtual/typed-array-constructor.js";
import { _ as t } from "./export.js";
import { g as o } from "./global.js";
import { f as e } from "./function-call.js";
import { d as s } from "./descriptors.js";
import { t as i } from "./typed-array-constructors-require-wrappers.js";
import { a } from "./array-buffer-view-core.js";
import { a as n } from "./array-buffer.js";
import { a as f } from "./an-instance.js";
import { c as p } from "./create-property-descriptor.js";
import { c as m } from "./create-non-enumerable-property.js";
import { i as c } from "./is-integral-number.js";
import { t as u } from "./to-length.js";
import { t as y } from "./to-index.js";
import { t as j } from "./to-offset.js";
import { t as l } from "./to-property-key.js";
import { h as b } from "./has-own-property.js";
import { c as d } from "./classof.js";
import { i as g } from "./is-object.js";
import { i as v } from "./is-symbol.js";
import { o as w } from "./object-create.js";
import { o as h } from "./object-is-prototype-of.js";
import { o as _ } from "./object-set-prototype-of.js";
import "./object-get-own-property-names.js";
import { t as A } from "./typed-array-from.js";
import { a as E } from "./array-iteration.js";
import { s as x } from "./set-species.js";
import { d as T } from "./define-built-in-accessor.js";
import "./object-define-property.js";
import "./object-get-own-property-descriptor.js";
import { i as R } from "./internal-state.js";
import { i as O } from "./inherit-if-required.js";
import { __exports as B } from "../../../_virtual/object-get-own-property-names.js";
import { __exports as P } from "../../../_virtual/object-define-property.js";
import { __exports as C } from "../../../_virtual/object-get-own-property-descriptor.js";
var L = B.f,
  Y = E.forEach,
  D = R.get,
  S = R.set,
  V = R.enforce,
  q = P.f,
  F = C.f,
  I = Math.round,
  M = o.RangeError,
  N = n.ArrayBuffer,
  W = N.prototype,
  k = n.DataView,
  G = a.NATIVE_ARRAY_BUFFER_VIEWS,
  U = a.TYPED_ARRAY_TAG,
  z = a.TypedArray,
  H = a.TypedArrayPrototype,
  J = a.aTypedArrayConstructor,
  K = a.isTypedArray,
  Q = "BYTES_PER_ELEMENT",
  X = "Wrong length",
  Z = function Z(r, t) {
    J(r);
    for (var o = 0, e = t.length, s = new r(e); e > o;) s[o] = t[o++];
    return s;
  },
  $ = function $(r, t) {
    T(r, t, {
      configurable: !0,
      get: function get() {
        return D(this)[t];
      }
    });
  },
  rr = function rr(r) {
    var t;
    return h(W, r) || "ArrayBuffer" == (t = d(r)) || "SharedArrayBuffer" == t;
  },
  rt = function rt(r, t) {
    return K(r) && !v(t) && t in r && c(+t) && t >= 0;
  },
  ro = function ro(r, t) {
    return rt(r, t = l(t)) ? p(2, r[t]) : F(r, t);
  },
  re = function re(r, t, o) {
    return rt(r, t = l(t)) && g(o) && b(o, "value") && !b(o, "get") && !b(o, "set") && !o.configurable && (!b(o, "writable") || o.writable) && (!b(o, "enumerable") || o.enumerable) ? (r[t] = o.value, r) : q(r, t, o);
  };
s ? (G || (C.f = ro, P.f = re, $(H, "buffer"), $(H, "byteOffset"), $(H, "byteLength"), $(H, "length")), t({
  target: "Object",
  stat: !0,
  forced: !G
}, {
  getOwnPropertyDescriptor: ro,
  defineProperty: re
}), r.exports = function (r, s, a) {
  var n = r.match(/\d+/)[0] / 8,
    p = r + (a ? "Clamped" : "") + "Array",
    c = "get" + r,
    l = "set" + r,
    b = o[p],
    d = b,
    v = d && d.prototype,
    h = {},
    E = function E(r, t) {
      var o = D(r);
      return o.view[c](t * n + o.byteOffset, !0);
    },
    T = function T(r, t, o) {
      var e = D(r);
      a && (o = (o = I(o)) < 0 ? 0 : o > 255 ? 255 : 255 & o), e.view[l](t * n + e.byteOffset, o, !0);
    },
    R = function R(r, t) {
      q(r, t, {
        get: function get() {
          return E(this, t);
        },
        set: function set(r) {
          return T(this, t, r);
        },
        enumerable: !0
      });
    };
  G ? i && (d = s(function (r, t, o, s) {
    return f(r, v), O(g(t) ? rr(t) ? void 0 !== s ? new b(t, j(o, n), s) : void 0 !== o ? new b(t, j(o, n)) : new b(t) : K(t) ? Z(d, t) : e(A, d, t) : new b(y(t)), r, d);
  }), _ && _(d, z), Y(L(b), function (r) {
    r in d || m(d, r, b[r]);
  }), d.prototype = v) : (d = s(function (r, t, o, s) {
    f(r, v);
    var i,
      a,
      p,
      m = 0,
      c = 0;
    if (g(t)) {
      if (rr(t)) {
        i = t, c = j(o, n);
        var l = t.byteLength;
        if (void 0 === s) {
          if (l % n || (a = l - c) < 0) throw M(X);
        } else if ((a = u(s) * n) + c > l) throw M(X);
        p = a / n;
      } else if (K(t)) return Z(d, t);else return e(A, d, t);
    } else a = (p = y(t)) * n, i = new N(a);
    for (S(r, {
      buffer: i,
      byteOffset: c,
      byteLength: a,
      length: p,
      view: new k(i)
    }); m < p;) R(r, m++);
  }), _ && _(d, z), v = d.prototype = w(H)), v.constructor !== d && m(v, "constructor", d), V(v).TypedArrayConstructor = d, U && m(v, U, p);
  var B = d != b;
  h[p] = d, t({
    global: !0,
    constructor: !0,
    forced: B,
    sham: !G
  }, h), Q in d || m(d, Q, n), Q in v || m(v, Q, n), x(p);
}) : r.exports = function () {};
var rs = r.exports;
export { rs as t };